/* Turnout Time by Schneiders — episode audio player.
   Vanilla JS, no deps. Initializes every .ttp player on the page (supports a
   featured player on the hub + the episode player on an article). Each root is
   self-contained; state lives on the element, not in any storage. */
(function () {
  var PLAY = 'M7 4v16l13-8z';
  var PAUSE = 'M6 4h4v16H6zM14 4h4v16h-4z';
  var RATES = [1, 1.25, 1.5, 2];

  function fmt(s) {
    if (!isFinite(s)) return '--:--';
    s = Math.floor(s);
    var m = Math.floor(s / 60);
    return m + ':' + ('0' + (s % 60)).slice(-2);
  }

  function init(root) {
    if (root.__ttpInit) return;
    root.__ttpInit = true;
    var a = root.querySelector('audio');
    if (!a) return;
    var q = function (sel) { return root.querySelector(sel); };
    var play = q('[data-ttp="play"]'), bar = q('[data-ttp="bar"]'),
        cur = q('[data-ttp="cur"]'), dur = q('[data-ttp="dur"]'),
        back = q('[data-ttp="back"]'), fwd = q('[data-ttp="fwd"]'),
        speed = q('[data-ttp="speed"]'), dl = q('[data-ttp="dl"]'), sh = q('[data-ttp="share"]');
    var seeking = false, ri = 0;
    function icon(d) { var p = play && play.querySelector('path'); if (p) p.setAttribute('d', d); }

    if (play) play.addEventListener('click', function () { a.paused ? a.play() : a.pause(); });
    a.addEventListener('play', function () { icon(PAUSE); if (play) play.setAttribute('aria-label', 'Pause episode'); });
    a.addEventListener('pause', function () { icon(PLAY); if (play) play.setAttribute('aria-label', 'Play episode'); });
    a.addEventListener('loadedmetadata', function () { if (dur) dur.textContent = fmt(a.duration); if (bar) bar.max = a.duration || 100; });
    a.addEventListener('timeupdate', function () { if (seeking) return; if (cur) cur.textContent = fmt(a.currentTime); if (bar) bar.value = a.currentTime; });
    a.addEventListener('ended', function () { a.currentTime = 0; });
    if (bar) {
      bar.addEventListener('input', function () { seeking = true; if (cur) cur.textContent = fmt(+bar.value); });
      bar.addEventListener('change', function () { a.currentTime = +bar.value; seeking = false; });
    }
    if (back) back.addEventListener('click', function () { a.currentTime = Math.max(0, a.currentTime - 15); });
    if (fwd) fwd.addEventListener('click', function () { a.currentTime = Math.min(a.duration || 0, a.currentTime + 30); });
    if (speed) speed.addEventListener('click', function () { ri = (ri + 1) % RATES.length; a.playbackRate = RATES[ri]; speed.textContent = RATES[ri] + '×'; });
    if (dl) dl.addEventListener('click', function () { window.open(a.currentSrc, '_blank'); });
    if (sh) sh.addEventListener('click', function () {
      if (navigator.share) { navigator.share({ title: 'Turnout Time by Schneiders', url: location.href }); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(location.href); sh.textContent = 'Link copied'; }
    });
    a.addEventListener('error', function () { if (dur) dur.textContent = '—'; if (cur) cur.textContent = '0:00'; });
  }

  function boot() {
    var roots = document.querySelectorAll('.ttp[data-ttp-player]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Theme Editor: re-init when a section is added/reloaded.
  document.addEventListener('shopify:section:load', boot);
})();
